import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const scrollToApplication = () => {
    document.getElementById('application-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 right-4 z-50 max-w-md bg-gradient-to-r from-purple-600 to-blue-600 text-white p-5 rounded-lg shadow-xl animate-bounce-slow" data-id="element-378">
      <div className="absolute -top-2 -right-2" data-id="element-379">
        <button onClick={() => setIsVisible(false)} className="bg-white text-purple-600 rounded-full p-1 shadow-md hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500" aria-label="Close notification" data-id="element-380">
          <XIcon size={16} data-id="element-381" />
        </button>
      </div>
      <div className="flex items-start" data-id="element-382">
        <div className="mr-4 mt-1" data-id="element-383">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center" data-id="element-384">
            <span className="text-2xl" data-id="element-385">🎓</span>
          </div>
        </div>
        <div data-id="element-386">
          <h3 className="font-bold text-lg mb-2" data-id="element-387">KS3 Maths Research Study</h3>
          <p className="text-white/90 mb-3" data-id="element-388">
            Join our large-scale RCT and receive free Eedi Plus access,
            including 1-to-1 online tutor support for all your KS3 students.
          </p>
          <div className="flex space-x-2" data-id="element-389">
            <button onClick={scrollToApplication} className="text-sm font-medium bg-white text-purple-700 px-4 py-1.5 rounded-full hover:bg-gray-100 transition-colors shadow-sm" data-id="element-390">
              Apply Now
            </button>
            <button onClick={() => setIsVisible(false)} className="text-sm font-medium bg-transparent border border-white text-white px-4 py-1.5 rounded-full hover:bg-white/10 transition-colors" data-id="element-391">
              Remind me later
            </button>
          </div>
        </div>
      </div>
    </div>;
}